exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".toast-container {\n  position: fixed;\n  z-index: 999999;\n  right: 0;\n  top: 0;\n  padding-top: 10px;\n  padding-right: 30px;\n  overflow: hidden; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/luvi/frontend/src/app/shared/services/toast/toast-container.component.scss
// module id = ../../../../../src/app/shared/services/toast/toast-container.component.scss
// module chunks = main